import { Skeleton } from "@components/Skeleton/Skeleton";

interface ITaxCollectorTypeListSkeletonProps {
  count: number;
}

export const TaxCollectorTypeListSkeleton: React.FC<
  ITaxCollectorTypeListSkeletonProps
> = (props) => {
  const { count } = props;

  return [...(Array(count) as unknown[])].map((_, index) => (
    <Skeleton
      key={index}
      variant="rectangular"
      className="h-[4.5rem] w-full basis-[calc(33.333%-(1rem*2/3))] rounded-lg"
    />
  ));
};
